if (!customElements.get('aura-hero-motion')) {
  customElements.define(
    'aura-hero-motion',
    class AuraHeroMotion extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('.aura-hero__video');
        this.toggle = this.querySelector('.aura-hero__toggle');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      connectedCallback() {
        if (!this.video) return;

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');

        this.video.addEventListener(
          'canplay',
          () => {
            if (!this.reducedMotion.matches) this.play();
          },
          { once: true }
        );

        if (this.reducedMotion.matches) {
          this.pause();
        } else {
          this.play();
        }

        this.reducedMotion.addEventListener('change', (event) => {
          if (event.matches) {
            this.pause();
          } else {
            this.play();
          }
        });

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            if (this.video.paused) {
              this.play();
            } else {
              this.pause();
            }
          });
        }
      }

      async play() {
        if (!this.video) return;

        try {
          await this.video.play();
          this.dataset.state = 'playing';
          this.dataset.videoReady = 'true';

          if (this.toggle) {
            this.toggle.setAttribute('aria-pressed', 'false');
            this.toggle.setAttribute('aria-label', this.toggle.dataset.pauseLabel);
          }
        } catch (_) {
          this.dataset.state = 'paused';

          if (this.toggle) {
            this.toggle.setAttribute('aria-pressed', 'true');
            this.toggle.setAttribute('aria-label', this.toggle.dataset.playLabel);
          }
        }
      }

      pause() {
        if (!this.video) return;

        this.video.pause();
        this.dataset.state = 'paused';

        if (this.toggle) {
          this.toggle.setAttribute('aria-pressed', 'true');
          this.toggle.setAttribute('aria-label', this.toggle.dataset.playLabel);
        }
      }
    }
  );
}